import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify';

import { allowEditingAction, cancelOrderAction, confirmRefundAction, markAsCommissionedAction, markAsDeliveredAction, releaseOrderAction, cancelOrderByPMMAction, cancelOrderByAdminAction, refundedPendingReviewAction, updateOrderStatusAction } from '../../../redux/actions/orderActions';

const SingleOrderButtons = ({ order, user, hideViewButton, setShowActionButtons }) => {






    const dispatch = useDispatch();
    const { message } = useSelector(state => state.order)

    const wrapperRef = useRef(null);



    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');

    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');







    const handleShowPopup = (status) => {


        setShowPopup(true);
        setActionToPerform(status);


        if (status === "DELIVERED") {
            setpopupHeading("Mark as Delivered");
            setpopupPara("Are you sure you want to mark this order as delivered?");
        }
        if (status === "ALLOW_EDITING") {
            setpopupHeading("Allow Editing");
            setpopupPara("Are you sure you want to allow editing for this order?");
        }
        if (status === "CONFIRM_REFUND") {
            setpopupHeading("Refund Acknowledgment Confirmation");
            setpopupPara(`
                By confirming this acknowledgment, you declare that you have received the full refund for this product (Expected Amount in USD: ${order?.product_price}).

                Once confirmed, you will not be able to submit any complaints, disputes, or reports related to refund issues for this order.

                Please ensure the refunded amount has been fully received before proceeding.`);
        }
        if (status === "CANCELLED") {
            setpopupHeading("Cancel Order");
            setpopupPara(`Are you sure you want to cancel this order?`);
        }
        if (status === "RELEASE_HOLD") {
            setpopupHeading("Release from Hold");
            setpopupPara(`Are you sure you want to release this order from hold?`);
        }
        if (status === "REVIEWED") {
            setpopupHeading("Mark as Reviewed");
            setpopupPara("Are you sure you want to move this order to Reviewed status?");
        }
        if (status === "ORDERED") {
            setpopupHeading("Move to Ordered");
            setpopupPara("Are you sure you want to move this order back to Ordered status?");
        }

    }



    const handleMarkAsCommissioned = () => {



        setShowPopup(true);
        setActionToPerform("COMMISSIONED")
        setpopupHeading("Mark as Commissioned")
        setpopupPara(`
                By marking this order as Commissioned, you confirm that the order has been successfully completed and the commission can be processed. Please ensure all necessary steps have been taken and the order is ready for commissioning before proceeding.`)


    }


    useEffect(() => {

         if (showPopup) return;
        const handleClickOutside = (event) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target)
            ) {
                setShowActionButtons(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setShowActionButtons,showPopup]);





    const handleDispatch = () => {

        console.log("CLICKED YES");
        console.log("ACTION:", actionToPerform);

        if (!actionToPerform) {
            console.log("NO ACTION FOUND");
            return toast.error("Please select an action to Perform");
        }



        if (!actionToPerform) return toast.error("Please select an action to Perform");



        if (actionToPerform === "DELIVERED") {
            dispatch(markAsDeliveredAction({ order_id: order?.id }));
        }
        if (actionToPerform === "ALLOW_EDITING") {
            dispatch(allowEditingAction({ order_id: order?.id }));
        }
        if (actionToPerform === "HidePopup") {
            setShowPopup(false)
        }


        if (actionToPerform === "CONFIRM_REFUND") {
            dispatch(confirmRefundAction({ order_id: order?.id }))
        }

        if (actionToPerform === "COMMISSIONED") {
            dispatch(markAsCommissionedAction({ order_id: order?.id }))
        }
        if (actionToPerform === "CANCELLED") {
            dispatch(cancelOrderAction({ order_id: order?.id }))
        }


        if (actionToPerform === "RELEASE_HOLD") {

            console.log(order?.id)

            dispatch(releaseOrderAction({ order_id: order?.id }))
        }

        if (actionToPerform === "REFUNDED_PENDING_REVIEW") {
            dispatch(refundedPendingReviewAction({ order_id: order?.id }));
        }

        if (actionToPerform === "ORDER_CANCELLED_BY_PMM") {
            dispatch(cancelOrderByPMMAction({ order_id: order?.id }));
        }

        if (actionToPerform === "CANCELLED_BY_ADMIN") {
            dispatch(cancelOrderByAdminAction({ order_id: order?.id }));
        }

        if (actionToPerform === "REVIEWED") {
            dispatch(updateOrderStatusAction({ order_id: order?.id, status: "REVIEWED" }))
        }
        if (actionToPerform === "ORDERED") {
            dispatch(updateOrderStatusAction({ order_id: order?.id, status: "ORDERED" }))
        }

    }





    useEffect(() => {
        if (message) {
            setShowPopup(false);
            setActionToPerform('');
        }
    }, [message])

    return (
        <Fragment>
            {(
                order?.status !== "CANCELLED" &&
                order?.status !== "SYSTEM_CANCELLED" &&
                order?.status !== "SUSPENDED") &&
                <div className={`flex w-max min-w-[12vmax] justify-end absolute top-[110%] right-0 z-[100] animate-in fade-in zoom-in duration-200`}
                    ref={wrapperRef}
                >
                    <div className="flex flex-col w-full bg-white/95 backdrop-blur-sm p-[0.5vmax] rounded-xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.15)] border border-gray-100 overflow-hidden" >

                        <Link
                            to={`/orders/remarks-on-order?order_id=${order?.id}`}
                            className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-blue-50 text-slate-600 hover:text-blue-600 transition-all duration-200"
                        >
                            <i className="fa-regular fa-message text-[1.1vmax] w-[1.5vmax] text-center"></i>
                            <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Remarks</span>
                        </Link>

                        <div className="my-[0.2vmax] border-t border-gray-50 mx-[0.5vmax]"></div>

                        {user?.role !== "PM" && (
                            order?.status !== "COMMISSIONED" &&
                            order?.status !== "COMPLETED" &&
                            order?.status !== "CANCELLED" &&
                            order?.status !== "REFUNDED") && order?.is_locked === 1 &&
                            <button
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-emerald-50 text-slate-600 hover:text-emerald-600 transition-all duration-200"
                                onClick={() => handleShowPopup("ALLOW_EDITING")}
                            >
                                <i className="fa-regular fa-pen-to-square text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Allow Editing</span>
                            </button>
                        }

                        {(user?.role === "ADMIN" || user?.role === "SUPER_ADMIN" || user?.role === "PMM" || order?.status === "REVIEWED" || order?.status === "ORDERED" || order?.status === "DELIVERED" || order?.status === "REFUNDED") &&
                            <Link
                                to={`/orders/on-hold?order_id=${order?.id}`}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-orange-50 text-orange-500 hover:text-orange-600 transition-all duration-200"
                            >
                                <i className="fa-regular fa-circle-pause text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">On Hold</span>
                            </Link>
                        }

                        {user?.role !== "PM" && (order?.status === "REVIEWED" || order?.status === "DELIVERED" || order?.status === "REFUNDED") &&
                            <Link to={`/orders/review-deleted?order_id=${order?.id}`}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-red-50 text-red-500 hover:text-red-600 transition-all duration-200"
                            >
                                <i className="fa-regular fa-trash-can text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Review Deleted</span>
                            </Link>
                        }

                        {(user?.role !== "PM" || (order?.status === "DELIVERED" || order?.status === "REVIEW_DELETED")) && !order?.refund_image_proof_url &&
                            <Link
                                to={`/orders/order-refunded?order_id=${order?.id}`}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-purple-50 text-slate-600 hover:text-purple-600 transition-all duration-200"
                            >
                                <i className="fa-regular fa-credit-card text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize text-left">
                                    {order?.status === "REVIEW_DELETED" ? "Add Refund Proof" : "Mark as Refunded"}
                                </span>
                            </Link>
                        }

                        {(user?.role === 'PMM' || user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') && (
                            <>
                                <button
                                    onClick={() => handleShowPopup("ORDERED")}
                                    className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-green-50 text-green-500 hover:text-green-600 transition-all duration-200"
                                >
                                    <i className="fa-solid fa-cart-shopping text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                    <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Ordered</span>
                                </button>

                                <button
                                    onClick={() => handleShowPopup("DELIVERED")}
                                    className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-blue-50 text-blue-500 hover:text-blue-600 transition-all duration-200"
                                >
                                    <i className="fa-solid fa-file-invoice text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                    <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Review Submitted Pending Refund</span>
                                </button>

                                <button
                                    onClick={() => handleShowPopup("REFUNDED_PENDING_REVIEW")}
                                    className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-yellow-50 text-yellow-500 hover:text-yellow-600 transition-all duration-200"
                                >
                                    <i className="fa-solid fa-clock text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                    <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Refunded Pending Review</span>
                                </button>

                                <button
                                    onClick={() => handleShowPopup("ORDER_CANCELLED_BY_PMM")}
                                    className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-red-50 text-red-500 hover:text-red-600 transition-all duration-200"
                                >
                                    <i className="fa-solid fa-ban text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                    <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Order Cancelled By PMM</span>
                                </button>
                            </>
                        )}

                        {(user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') && (
                            <button
                                onClick={() => handleShowPopup("CANCELLED_BY_ADMIN")}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-red-50 text-red-500 hover:text-red-600 transition-all duration-200"
                            >
                                <i className="fa-solid fa-user-slash text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Cancelled by Admin</span>
                            </button>
                        )}

                        {user?.role === "PM" && order?.status === "ORDERED" &&
                            <Link
                                to={`/orders/review-order?order_id=${order?.id}`}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-pink-50 text-slate-600 hover:text-pink-600 transition-all duration-200"
                            >
                                <i className="fa-regular fa-star text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Submit Review</span>
                            </Link>
                        }

                        {user?.role === "PM" && order?.status === "ON_HOLD" &&
                            <button
                                onClick={() => {
                                    setShowPopup(true);
                                    setActionToPerform("RELEASE_HOLD");
                                    setpopupHeading("Release from Hold");
                                    setpopupPara("Are you sure you want to release this order from hold and mark it as Ordered?");
                                }}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-green-50 text-green-500 hover:text-green-600 transition-all duration-200"
                            >
                                <i className="fa-solid fa-arrow-rotate-left text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Mark as Ordered</span>
                            </button>
                        }

                        {user?.role === "PM" && order?.status === "REVIEWED" && order?.is_locked === 0 &&
                            <Link
                                to={`/orders/edit_order?order_id=${order?.id}`}
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-indigo-50 text-slate-600 hover:text-indigo-600 transition-all duration-200"
                            >
                                <i className="fa-solid fa-pen text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Edit Order</span>
                            </Link>
                        }

                        {user?.role !== "PM" && (order?.status === "REVIEWED") &&
                            <button
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-cyan-50 text-slate-600 hover:text-cyan-600 transition-all duration-200"
                                onClick={() => handleShowPopup("DELIVERED")}
                            >
                                <i className="fa-regular fa-paper-plane text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize text-left">Mark Delivered</span>
                            </button>
                        }

                        {
                            user?.role === "PM" && order?.status === "REFUNDED" && order?.refund_confirmed === 0 &&
                            <button
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-green-50 text-slate-600 hover:text-green-600 transition-all duration-200"
                                onClick={() => handleShowPopup("CONFIRM_REFUND")}
                            >
                                <i className="fa-solid fa-check-double text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize text-left">Acknowledge Refund</span>
                            </button>
                        }
                        {
                            user?.role !== "PM" && order?.status === "ON_HOLD" &&
                            <button
                                className="group w-full flex items-center gap-[0.8vmax] px-[1vmax] py-[0.6vmax] rounded-lg hover:bg-indigo-50 text-slate-600 hover:text-indigo-600 transition-all duration-200"
                                onClick={() => handleShowPopup("RELEASE_HOLD")}
                            >
                                <div className="w-[2.2vmax] h-[2.2vmax] flex-center rounded-md bg-gray-50 group-hover:bg-indigo-100 transition-colors">
                                    <i className="fa-solid fa-play text-[1vmax]"></i>
                                </div>
                                <span className="text-[1.3vmax] lg:text-[0.9vmax] font-medium capitalize">Release Hold</span>
                            </button>
                        }

                        {user?.role !== "PM" && (order?.status === "REFUNDED" || order?.status === "ORDER_CANCELLED_BY_PMM" || order?.status === "REVIEWED" || order?.status === "DELIVERED") &&
                            <button
                                className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-amber-50 text-slate-600 hover:text-amber-600 transition-all duration-200"
                                onClick={() => handleMarkAsCommissioned()}
                            >
                                <i className="fa-solid fa-coins text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize text-left">Commissioned</span>
                            </button>
                        }

                        {order?.status === "ORDERED" && user?.role === "PM"
                            &&
                            <button className="group w-full flex items-center gap-2 px-3 py-1.5 rounded hover:bg-red-50 text-red-500 hover:text-red-600 transition-all duration-200"
                                onClick={() => handleShowPopup("CANCELLED")}
                            >
                                <i className="fa-regular fa-circle-xmark text-[1.1vmax] w-[1.5vmax] text-center"></i>
                                <span className="text-[1.1vmax] lg:text-[0.85vmax] font-medium capitalize">Cancel Order</span>
                            </button>
                        }
                    </div>
                </div>
            }
            {(
                order?.status === "CANCELLED" ||
                order?.status === "SYSTEM_CANCELLED" ||
                order?.status === "SUSPENDED") && !hideViewButton &&
                <div className={`flex  w-[300%] lg:w-[15vmax] justify-end absolute top-[100%] right-[2vmax]  z-[100] `}
                    ref={wrapperRef}
                >
                    <div className="flex-center   flex-center gap-[0.8vmax]  py-[1vmax] px-[1vmax] rounded-2xl shadow-2  flex-col bg-white border-2 " >
                        <Link
                            to={`/orders/order-details?order_id=${order?.id}`}
                            className={`w-full  grid grid-cols-[0.8fr_3fr] items-center gap-[0.5vmax]    hover:scale-[0.9] text-slate-600 text-[1.5vmax] lg:text-[1vmax] capitalize 
                           `}
                        >
                            <i className="fa-regular fa-eye text-[0.9vmax]"></i>
                            <span>view</span>
                        </Link>
                    </div>
                </div>

            }

            {showPopup &&
                <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-zinc-900/60 backdrop-blur-sm p-4">
                    {/* Close Button on Overlay */}
                    <button 
                        className="fixed top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-lg"></i>
                    </button>

                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden border border-zinc-100">
                        {/* Content */}
                        <div className="p-6 flex flex-col items-center text-center gap-4">
                            <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center text-sky-500">
                                <i className="fa-solid fa-circle-question text-2xl"></i>
                            </div>
                            <div className="flex flex-col gap-2">
                                <h2 className="text-xl font-bold text-zinc-900">{popupHeading}</h2>
                                <p className="text-sm text-zinc-500 whitespace-pre-line leading-relaxed">
                                    {popupPara}
                                </p>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="flex justify-center gap-3 p-6 bg-zinc-50 border-t border-zinc-100">
                            {actionToPerform !== "HidePopup" && (
                                <button 
                                    className="flex-1 px-4 py-2.5 bg-white border border-zinc-200 text-zinc-600 hover:text-zinc-700 font-bold text-sm rounded-xl hover:bg-zinc-50 transition-colors shadow-sm"
                                    onClick={() => {
                                        setShowPopup(false)
                                        setActionToPerform("")
                                    }}
                                >
                                    No
                                </button>
                            )}

                            <button 
                                className={`flex-1 px-4 py-2.5 bg-gradient-to-br from-sky-500 to-indigo-600 text-white font-bold text-sm rounded-xl hover:shadow-md transition-all shadow-sm ${actionToPerform === "HidePopup" ? "max-w-[120px]" : ""}`}
                                onClick={handleDispatch}
                            >
                                {actionToPerform === "HidePopup" ? "Close" : 
                                 actionToPerform === "CONFIRM_REFUND" ? "I Acknowledge" :
                                 actionToPerform === "COMMISSIONED" ? "Mark as Commissioned" : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    )
}

export default SingleOrderButtons